(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-hp"] && !window.DesignMode) return;
  try {
    

    const swiperFeatured = new Swiper(".featured-collection_wrapper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        360: {
  loop: true,
            slidesPerView: 1,
        },
        640: {
            slidesPerView: 2,
  loop: true,
        },
        990: {
            slidesPerView: 3,
  loop: true,
        }
        ,
        1024: {
            slidesPerView: 4,
  loop: true,
        }
    }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-hp"] && !window.DesignMode) return;
  try {
    

const swiperFeatruedProduct = new Swiper(".featrued-product-hp_container", {
      slidesPerView: 1,
  loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const submitButton = document.querySelector('.klaviyo_submit_button');
  const emailInput = document.querySelector('#k_id_email');

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  submitButton.addEventListener('click', function (e) {
    if (validateEmail(emailInput.value)) {
      emailInput.classList.remove('error-border');
    } else {
      emailInput.classList.add('error-border');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const body = document.querySelector('body');
  const header = document.querySelector('header.header');
  header.classList.contains('sticky') ? body.classList.add('sticky') : false;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-header"] && !window.DesignMode) return;
  try {
    

    const swiper = new Swiper(".collection-header_carousel-container", {
        slidesPerView: 7,
        slidesPerGroup: 7,
        loop: true,
        navigation: {
            nextEl: '.header-slides_prev',
            prevEl: '.header-slides_next',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            900: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            1024: {
                slidesPerView: 6,
                slidesPerGroup: 6,
            }
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-support"] && !window.DesignMode) return;
  try {
    
    const questions = document.querySelectorAll(".q");

    questions.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("open");
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !window.DesignMode) return;
  try {
    

    const swiper = new Swiper(".review-carousel_swiper", {
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            360: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            }
        }
    });
    
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scp_info"] && !window.DesignMode) return;
  try {
    
  const swiperSCP = new Swiper(".scp-carousel", {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      640: {
        spaceBetween: 32,
        slidesPerView: 2,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-chexx-pro-features"] && !window.DesignMode) return;
  try {
    
    const lifestyleCarousel = new Swiper(".lifestyle-carousel", {
          slidesPerView: 1,
          pagination: {
            el: ".lifestyle-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: '.right-arrow',
            prevEl: '.left-arrow',
          }
    });

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.play-button').addEventListener('click', function (e) {
        //get video id for play/pause
        const button = e.target.closest(".play-button");
        const id = button.getAttribute("data-video-id");
        if (button.style.opacity == '1' || button.style.opacity == '') {
            document.querySelector('#' + id).play();
            button.style.opacity = 0;
        } else {
            document.querySelector('#' + id).pause();
            button.style.opacity = 1;
        }
    });
});


  } catch(e) { console.error(e); }
})();
})();
